// A classic script at the end of <body>, after the CDN jQuery and its plugins. A Turbo visit
// re-runs every <body> script in order, this one last, while modules run once per document;
// modules/page_load.js listens for this event to set up the page Turbo rendered. On a full page
// load it runs before any module, so nothing is listening yet.
document.dispatchEvent(new CustomEvent('body-scripts:ran'));
